<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Revoke Tokens</h4>
                <!-- Close -->
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to revoke the following tokens?</p>
                <ul class="list-group list-group-sm">
                    <li v-for="item in modalData" :key="item.index" class="list-group-item">
                        {{item.email}} ({{ item.id }})
                    </li>
                </ul>
            </div>
            <div class="card-footer text-end">
                <button class="btn btn-danger">
                    <div
                        v-if="revokeInProgress"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        >
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else><slot></slot>Revoke</div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            token: {},
            revokeInProgress: false
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "RevokeTokens",
    methods: {
        ...mapActions("admin", {
            revokeToken: "revokeToken",
        }),
        async onFormSubmit() {
            this.revokeInProgress = true;
            try {
                for (const token of this.modalData) {
                    await this.revokeToken(token.id)
                }
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                return;
            } finally {
                this.revokeInProgress = false;
            }

            this.$store.dispatch("hideModal");
            if(this.$store.getters.userRoles.isAqferAdmin){
                     this.$store.dispatch("admin/fetchAllRefreshTokens");
            }
            this.$store.dispatch("admin/fetchClientsAllRefreshTokens");
        },
    },
};
</script>

<style>
</style>